import { render, staticRenderFns } from "./ProjectEditModal.vue?vue&type=template&id=10f64e0d&"
import script from "./ProjectEditModal.vue?vue&type=script&lang=js&"
export * from "./ProjectEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports